import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DeviceDetailsPageComponent } from './device-details-page.component';

const routes: Routes = [
  {
    path: 'device-details',
    data: { name: 'Device Details', isTab: true },
    component: DeviceDetailsPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DeviceDetailsPageRoutingModule {}
